module.exports = __webpack_public_path__ + "img/bank-account-switch.ce707e38.svg";